import React, { useEffect, useState } from 'react'
import { Box, Chip, Icon, Typography } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AdxInput from 'components/custom/AdxInput'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'
import { useQuery } from 'react-query'
import { getForm } from 'services/api/modules/performance/appraisal/form'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'
import { getEvaluation } from 'services/api/modules/performance/appraisal/evaluation'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import AdxButton from 'components/custom/AdxButton'

const matching = [
  { id: 1, title: 'Self - Reviewer and Reviewee will be the same person' },
  { id: 2, title: 'Downstream - Supervisor as reviewer and Subordinate as reviewee' },
  { id: 3, title: 'Upstream - Subordinate as reviewer and Supervisor as reviewee' },
  {
    id: 4,
    title: 'Custom - Upload external matching CSV when this evalulation is added to an appraisal',
  },
]
function ViewEvaluation() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const evalId = pathname.split('/').pop()
  const [evaluationTitle, setEvaluationTitle] = useState('')
  const [description, setDescription] = useState('')
  const [getQuery, setGetQuery] = useState(false)
  const [formTitle, setFormTitle] = useState('')
  const [departmentSelected, setDepartmentSelected] = useState([])
  const [matchingSelected, setMatchingSelected] = useState('')
  const [switchFeedback, setSwitchFeedback] = useState(true)
  const [selectReviewer, setSelectReviewer] = useState(false)
  const [selectReviewee, setSelectReviewee] = useState(false)
  const [switchAnonymous, setSwitchAnonymous] = useState(false)

  const {
    isLoading,
    error: fetchError,
    data: evaluationData,
  } = useQuery(['evalData', evalId], async () => {
    const { data } = await getEvaluation(evalId)
    return data
  })

  const { data: formData } = useQuery(
    ['formData', evaluationData?.['Evaluation']?.['form_id']],
    async () => {
      const { data } = await getForm(evaluationData?.['Evaluation']?.['form_id'])

      return data
    },
    { enabled: getQuery }
  )

  const { data: departmentData } = useQuery(
    ['allDepartmentDataView', evaluationData?.['Evaluation']?.['participant_departments']],
    async () => {
      const newData = { name: 'All Departments', id: 'all' }
      let { data } = await getAllDepartment()
      if (data) {
        data.push(newData)
        const evalDepartments = evaluationData?.['Evaluation']?.['participant_departments']
        let arr = []

        data?.map((item) =>
          evalDepartments.map((evalDept) => (item.id === evalDept ? arr.push(item) : null))
        )
        data = arr
        return data
      }
    },
    { enabled: getQuery }
  )

  useEffect(() => {
    const data = formData?.['form']
    setFormTitle(data)
  }, [formData])

  useEffect(() => {
    setDepartmentSelected(departmentData)
  }, [departmentData])

  useEffect(() => {
    const data = evaluationData?.['Evaluation']

    data ? setGetQuery(true) : setGetQuery(false)

    setEvaluationTitle(data?.['title'])

    setDescription(data?.['description'])

    matching.map((item) => {
      if (item.id === data?.['participant_match_type_id']) {
        setMatchingSelected(item.title)
      }
    })

    data?.['has_feedback'] === 1 ? setSwitchFeedback(true) : setSwitchFeedback(false)

    data?.['is_anonymous'] === 1 ? setSwitchAnonymous(true) : setSwitchAnonymous(false)

    data?.['is_revieweeView'] === 1 ? setSelectReviewee(true) : setSelectReviewee(false)

    data?.['is_reviewerView'] === 1 ? setSelectReviewer(true) : setSelectReviewer(false)
  }, [evaluationData])

  // const handlePreview = () => {
  //   navigate(`/app/management-centre/company-management/appraisal/form/preview/${formTitle?.['id']}`, {
  //     // state: { evalSetting: true },
  //   })
  // }

  const handleReviewer = () => {
    setSelectReviewer(!selectReviewer)
  }

  const handleReviewee = () => {
    setSelectReviewee(!selectReviewee)
  }

  const handleExit = () => {
    window.opener = null
    window.open('', '_self')
    window.close()
  }
  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        maxWidth: '100vw',
        gap: 2,
        pb: 3,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {/* Header */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white.main',
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
          position: 'sticky',
          top: 0,
          zIndex: 999,
          px: 3,
          py: 2,
        }}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Typography variant="h4">{evaluationTitle}</Typography>
          <AdxStatusBar
            status={{
              text: 'Preview',
              color: 'alternate.main',
              bgColor: 'alternate.light',
            }}
            py={1 / 3}
            sx={{ borderRadius: '4.5px' }}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={3}>
          <Icon
            onClick={() => {
              evaluationData?.['Evaluation']?.['is_template'] === 0
                ? handleExit()
                : navigate('/app/management-centre/company-management/appraisal')
              // window.location.reload(false)
            }}
            sx={{ fontSize: 25, cursor: 'pointer' }}
          >
            close
          </Icon>
        </Box>
      </Box>

      {/* Body */}
      {/* General */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            General
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Name</Typography>
            <AdxInput placeholder={evaluationTitle} disabled />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Description</Typography>
            <AdxInput multiline placeholder={description} disabled />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Form Selection</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <AdxInput size="standard" placeholder={formTitle?.['title']} disabled />
              <Link
                to={`/app/management-centre/company-management/appraisal/form/preview/${formTitle?.['id']}`}
                target="_blank"
                style={{ textDecoration: 'none', color: 'white' }}
              >
                <AdxButton
                  variant={'contained'}
                  sx={{ width: 200 }}
                  size="standard"
                  // onClick={handlePreview}
                >
                  Preview
                </AdxButton>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Participant */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Participant
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Department Selection</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                overflowX: 'auto',
                gap: '5px',
              }}
            >
              {departmentSelected?.map((value) => (
                <Chip key={value.id} label={value.name} />
              ))}
            </Box>
          </Box>
          {/* Matching rule */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Matching Method </Typography>
            <AdxInput size="standard" placeholder={matchingSelected} disabled />
          </Box>
        </Box>
      </Box>

      {/* Other */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Other
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          {/* Feedback visibility */}
          {/* <Box>
          <Typography variant="body1">Evaluation Result Visibility:</Typography>
          <Typography variant="subtitle2" color="gray">
            Evaluation results will be visible to the selected type of user(s).
          </Typography>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <AdxFormControlLabel
            type="no-fill"
            control={<AdxCheckbox onChange={handleReviewer} checked={selectReviewer} />}
            label="Reviewer"
            disabled
          />
          <AdxFormControlLabel
            type="no-fill"
            control={<AdxCheckbox onChange={handleReviewee} checked={selectReviewee} />}
            label="Reviewee"
            disabled
          />
        </Box> */}

          {/* Enabling evaluation feedback */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Evaluation feedback</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to leave feedback after they have reviewed their evaluation result.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchFeedback}
              onChange={() => {
                setSwitchFeedback(!switchFeedback)
              }}
              disabled
            />
          </Box>

          {/* Anonymous submission */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Anonymous submission</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to submit evaluation anonymously.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchAnonymous}
              onChange={() => {
                setSwitchAnonymous(!switchAnonymous)
              }}
              disabled
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ViewEvaluation
